/**
 * Official Google Preferred Sources badge (deeplink).
 * @see https://developers.google.com/search/docs/appearance/preferred-sources
 */
const PREFERRED_SOURCE_URL = 'https://www.google.com/preferences/source?q=smartmetrics.com'

export default function PreferredSourceButton() {
  return (
    <a
      href={PREFERRED_SOURCE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex shrink-0 overflow-hidden rounded-[8px] transition-opacity hover:opacity-90"
      title="Add as a preferred source on Google"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/images/resources/google-preferred-source.png"
        srcSet="/images/resources/google-preferred-source.png 1x, /images/resources/google-preferred-source-2x.png 2x"
        alt="Add as a preferred source on Google"
        width={126}
        height={40}
        className="h-10 w-auto"
      />
    </a>
  )
}
